import * as React from 'react';
import { MultiPosting } from './MultiPosting';
import { useIsMobileDevice, useMultiPostingDescription } from '../../../../hooks';
import { ApplicationContext } from '../../../ApplicationContext';
import { useDispatch, useSelector } from 'react-redux';
import { changeMultiPostingEnabled } from '../../../../redux/reducers';
import { selectIsMultiPostingAvailable, selectMultipostingABGroup } from '../../../../selectors/publishTerms';
import { selectIsMultiPostingEnabled } from '../../../../selectors/offer/selectIsMultiPostingEnabled';
import { getLabelText } from '../../../../utils/multiposting/getLabelText';

export function MultiPostingContainer() {
  const dispatch = useDispatch();
  const isMobile = useIsMobileDevice();
  const { config } = React.useContext(ApplicationContext);
  const freeDate = config.get<string>('multiPosting.freeDate');
  const abGroup = useSelector(selectMultipostingABGroup);
  const text = useMultiPostingDescription();
  const termsUrl = String(config.get('addformConfig.multiPosting.termsUrl'));
  const isMultiPostingAvailable = useSelector(selectIsMultiPostingAvailable);
  const isMultiPostingChecked = useSelector(selectIsMultiPostingEnabled);

  const labelText = getLabelText(freeDate, abGroup);

  const handleChange = React.useCallback(
    checked => {
      dispatch(changeMultiPostingEnabled(checked));
    },
    [dispatch],
  );

  if (!isMultiPostingAvailable) {
    return null;
  }

  return (
    <MultiPosting
      isMobile={isMobile}
      checked={isMultiPostingChecked}
      text={text}
      labelText={labelText}
      termsUrl={termsUrl}
      onChange={handleChange}
    />
  );
}
